import {Component, OnInit, OnDestroy, Inject, ViewChild, ElementRef, AfterViewInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {MatDialogRef, MAT_DIALOG_DATA} from '@angular/material/dialog';
import {Subscription} from 'rxjs';
import {BranchNameService} from '../../../core/services/brand-name.service';
import {ToastrService} from 'ngx-toastr';
import {Message} from '../../../core/class/message';

interface DefaultFormData {
  name: string;
  username: string;
  password: string;
  type: string;
  cpCode: string;
  serviceId: string;
}

@Component({
  selector: 'app-edit-account-brandname',
  templateUrl: './edit-account-brandname.component.html',
  styleUrls: ['./edit-account-brandname.component.scss']
})
export class EditAccountBrandnameComponent implements OnInit, OnDestroy {

  isFormChanging = false;
  defaultFormData: DefaultFormData | null = null;
  form: FormGroup;
  formChangesSubscription: Subscription | undefined;

  constructor(
    private fb: FormBuilder,
    private dialogRef: MatDialogRef<EditAccountBrandnameComponent>,
    private brandNameService: BranchNameService,
    private toastr : ToastrService,
    private message : Message,
    @Inject(MAT_DIALOG_DATA) public data: DefaultFormData
  ) {
    // Khởi tạo form
    this.form = this.fb.group({
      name: [data && data.name ? data.name : '', Validators.required],
      username: [data && data.username ? data.username : '', Validators.required],
      password: [data && data.password ? data.password : '', Validators.required],
      type: [data && data.type ? data.type : '', Validators.required],
      cpCode: [data && data.cpCode ? data.cpCode : '', Validators.required],
      serviceId: [data && data.serviceId ? data.serviceId : '', Validators.required],
    });
  }

  ngOnInit() {
    this.formChangesSubscription = this.form.valueChanges.subscribe(() => {
      this.isFormChanging = true;
    });
  }

  ngOnDestroy() {
    if (this.formChangesSubscription) {
      this.formChangesSubscription.unsubscribe();
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }

  updateBrandName(data: any): void {
    if (this.form.valid) {
      const updatedData: DefaultFormData = this.form.value;

      this.brandNameService
        .addAccountInfor(updatedData.name, updatedData.username, updatedData.password, updatedData.type, updatedData.cpCode, updatedData.serviceId)
        .subscribe({
          next: res => {
            if (res && res.success) {
              this.toastr.success(this.message.getMessage('brand_name.updated_success'));
              this.dialogRef.close(true);
            } else {
              this.toastr.error(this.message.getMessage('brand_name.updated_fail'));
            }
          },
          error: err => {
            this.toastr.error(this.message.getMessage('brand_name.updated_fail'));
          }
        });
    }
  }
}
